/** Input shape for geocoding (e.g. PracticeLocation fields). */
export interface GeocodeInput {
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

/** Geocode a US-style address via Nominatim (OpenStreetMap). Returns [lat, lng] or null. */
export async function geocodeAddress(input: GeocodeInput): Promise<[number, number] | null> {
  const query = [input.address, input.city, input.state, input.zipCode]
    .filter(Boolean)
    .join(', ');
  if (!query.trim()) return null;
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?${new URLSearchParams({
        q: query,
        format: 'json',
        limit: '1',
      })}`,
      { headers: { Accept: 'application/json' } }
    );
    const data = await res.json();
    if (Array.isArray(data) && data[0]?.lat != null && data[0]?.lon != null) {
      return [Number(data[0].lat), Number(data[0].lon)];
    }
  } catch {
    // ignore
  }
  return null;
}
